document.addEventListener("turbo:load", () => {
  const container = document.getElementById("domain_fields");
  if (!container) return;

	console.log('Load: events/domains.js');

  const radios = document.querySelectorAll('input[name="domain[domain_type]"]');
  const groups = {
    "0": document.getElementById("group_domain_domain_type_0"),
    "1": document.getElementById("group_domain_domain_type_1"),
    "2": document.getElementById("group_domain_domain_type_2")
  };

  function updateDomainFields(selectedValue) {
    Object.entries(groups).forEach(([value, group]) => {
      if (!group) return;

      const active = value === selectedValue;
      group.style.display = active ? "" : "none";

      group.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = !active
      });
    });
  }

  const checked = document.querySelector('input[name="domain[domain_type]"]:checked');
  if (checked) updateDomainFields(checked.value);

  radios.forEach((radio) => {
    radio.addEventListener("change", () => updateDomainFields(radio.value));
  });
});